<template>
  <div v-if="render">
    <b-row class="mt-5">
      <b-col md="8"> </b-col>
      <b-col md="4">
        <h4 class="card-title mb-4">{{ $t('maintenance.order.form.serviceFee') }}</h4>
        <dl class="mc-list-total">
          <dt>{{ $t('maintenance.order.form.partsTotal') }}</dt>
          <dd class="text-end">
            {{ $t('maintenance.order.form.rp') }}
            {{ thousandFormat(serviceOrder?.aggregate?.totalPartPrice) }}
          </dd>
          <dt>{{ $t('maintenance.order.form.serviceTotal') }}</dt>
          <dd class="text-end">
            {{ $t('maintenance.order.form.rp') }}
            {{ thousandFormat(serviceOrder?.aggregate?.totalLabourPrice) }}
          </dd>
          <dt>{{ $t('maintenance.order.form.otherFees') }}</dt>
          <dd>
            <FormulateInput
              name="otherFee"
              v-model="otherFee"
              type="text"
              required
              validation-behavior="live"
              error-behavior="live"
              validation="number"
              @blur-context="handleSubmit"
              class="maintenance-detail__total-price"
              :disabled="isAllDisabled"
            >
              <template #prefix>
                <div class="formulate-input-prefix">
                  <span>{{ $t('maintenance.order.form.rp') }}</span>
                </div>
              </template>
            </FormulateInput>
          </dd>
          <dt>{{ $t('maintenance.order.form.additionalDiscount') }}</dt>
          <dd>
            <FormulateInput
              name="discount"
              v-model="discount"
              required
              validation-behavior="live"
              error-behavior="live"
              validation="number"
              @blur-context="handleSubmit"
              class="maintenance-detail__total-price"
              :disabled="isAllDisabled"
            >
              <template #prefix>
                <div class="formulate-input-prefix">
                  <span>{{ $t('maintenance.order.form.rp') }}</span>
                </div>
              </template>
            </FormulateInput>
          </dd>
          <dt>{{ $t('maintenance.order.form.tax') }}</dt>
          <dd>
            <FormulateInput
              name="tax"
              v-model="tax"
              required
              validation-behavior="live"
              error-behavior="live"
              validation="number"
              @blur-context="handleSubmit"
              class="maintenance-detail__total-price"
              :disabled="isAllDisabled"
            >
              <template #prefix>
                <div class="formulate-input-prefix">
                  <span>{{ $t('maintenance.order.form.rp') }}</span>
                </div>
              </template>
            </FormulateInput>
          </dd>
          <dt>
            <h5 class="teal-300">{{ $t('maintenance.order.form.serviceFeeTotal') }}</h5>
          </dt>
          <dd class="text-end">
            <h5>{{ $t('maintenance.order.form.rp') }} {{ thousandFormat(serviceOrder?.price) }}</h5>
          </dd>
        </dl>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Helper } from '@/mixin/helper'
import { GET_SERVICE_ORDER, UPDATE_SERVICE_ORDER } from '@/services/api/maintenance/serviceorder'

export default {
  mixins: [Helper],

  apollo: {
    serviceOrder: {
      query: GET_SERVICE_ORDER,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            serviceOrderId: +this.$route.params.id,
          },
        }
      },
      result({ data, loading }) {
        this.render = false
        if (loading) return
        this.serviceOrder = data.serviceOrder.serviceOrder

        this.otherFee = this.serviceOrder.otherFee ?? 0
        this.discount = this.serviceOrder.discount ?? 0
        this.tax = this.serviceOrder.tax ?? 0

        this.oldData = {
          otherFee: +this.otherFee,
          discount: +this.discount,
          tax: +this.tax,
        }

        this.render = true
      },
    },
  },
  props: {
    status: {
      type: String,
      default: 'Draft',
    },
    refreshPage: {},
  },

  data() {
    return {
      serviceOrder: {},
      otherFee: 0,
      discount: 0,
      tax: 0,
      render: true,
      oldData: {},
      isAllDisabled: false,
    }
  },
  watch: {
    status: {
      handler() {
        this.isAllDisabled = this.status != 'Draft' && this.status != 'Verification'
      },
      immediate: true,
    },
    refreshPage: function () {
      if (this.refreshPage) this.$apollo.queries.serviceOrder.refetch()

      this.$emit('pageRefreshed')
    },
  },

  methods: {
    async handleSubmit(value) {
      if (this.oldData[value.name] == this[value.name]) return

      this[value.name] = value.model

      const newData = {
        otherFee: +this.otherFee,
        discount: +this.discount,
        tax: +this.tax,
      }

      const res = await this.$apollo.mutate({
        mutation: UPDATE_SERVICE_ORDER,
        variables: {
          input: {
            serviceOrderId: +this.serviceOrder.serviceOrderId,
            oldData: this.oldData,
            newData,
          },
        },
      })

      if (res.data.updateServiceOrder.isSuccessful) {
        this.$mcToast.success(this.$t('global.alert.text.saved'))

        this.render = false

        setTimeout(() => {
          this.$apollo.queries.serviceOrder.refetch()

          this.render = true
        }, 1000)
      }
    },
  },
}
</script>

<style lang="scss">
.maintenance-detail__total-price {
  input {
    text-align: end !important;
  }
}
</style>
